import type { CheckoutOptions, Options } from "@/types/OptionsTypes";
import { BaseHttpService } from "@/api/http/BaseHttpService";
import { OPTIONS_FILE_MAPPING } from "@/constants/files";

export const optionsEndpoints = {
  index: "borrower_platform/options",
  checkout: "borrower_platform/options/checkout",
} as const;

export class OptionsHttpService extends BaseHttpService {
  screenLoadingPaths = [];

  async getOptions() {
    const { data } = await this.get<{ data: Options }>(optionsEndpoints.index, {
      params: { file_mapping: OPTIONS_FILE_MAPPING },
    });
    return data;
  }

  async getCheckoutOptions() {
    const { data } = await this.get<{ data: CheckoutOptions }>(optionsEndpoints.checkout);
    return data;
  }
}
